export const diamondData = {
    Diamond: {
        sizeOptions: {
            "2mm": {
                carat: "0.03 ct",
                price: 100,
                mm: 2,
            },
            "3mm": {
                carat: "0.1 ct",
                price: 120,
                mm: 3,
            },
            "4mm": {
                carat: "0.25 ct",
                price: 150,
                mm: 4,
            },
        },
    },
};
